import { Badge, BADGE_VARIANTS } from 'ui/badge';
import styled, { css } from 'styled-components';
import { colors } from 'ui/theme';

const StyledBadge = styled(Badge)<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${colors.textDisabled};
    `}
`;

export const CAMPAIGN_ID_BADGE_TEST_ID = 'campaign-id-badge';
export const CampaignIdBadge = ({ isDisabled }: { isDisabled?: boolean }) => (
  <StyledBadge
    data-test={CAMPAIGN_ID_BADGE_TEST_ID}
    variant={BADGE_VARIANTS.NEUTRAL}
    $isDisabled={isDisabled}
  >
    campaignId
  </StyledBadge>
);
